//
// 2020 - given a Product data object that has a .images member (or just the .images),
// provide a structured way to access it.
//
import {find} from "lodash";

// 2026-09 updated to use Zoidberg published images, and URL over path
export default class ProductImageCollection {
  constructor({product, images}) {
    this.product = product || {images: {}};
    this.images = images;

    if (!this.images)
      this.images = this.product.images || {};
  }

  // this.images has keys small, mid, large, square;
  // each value in the hash is a list of { {path: "/virtual/path"}, { path: "/virtual/path" } }
  getImages(size) {
    return this.images[size];
  }

  // returns the first virtual path of an image in the lsit
  getFirstImagePath(size) {
    console.log("getFirstImagePath", size, this.images);
    window.BOB ||= []
    window.BOB.push(this.images);

    let list = this.images[size];
    if (!list) return null;

    let img = find(list,  i => i.url || i.path);
    if (img) {
      return img.url || img.path;
    }

    return null;
  }
}
